export default [
  {
    title: 'DEBTIA_DEBTORS',
    route: 'debtors-list',
    icon: 'UserIcon',
    action: 'read',
    resource: 'Auth',
  },
]
